export enum JobPosition {
  Employee = 'Employee',
  LowerOfficer = 'Lower officer',
  UpperOfficer = 'Upper officer',
  Leader = 'Leader',
  Entrepreneur = 'Entrepreneur',
  Farmer = 'Farmer',
  LowerLevel = 'Lower-level employee',
  Management = 'Management',
  Pensioner = 'Pensioner',
  SeniorLevel = 'Senior-level employee',
  Student = 'Student',
}
